"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listFloatingIpActions = void 0;
const listFloatingIpActions = ({ httpClient, }) => ({ ip, page = 1, per_page = 25, }) => {
    const path = '/floating_ips';
    const query_params = { page, per_page };
    const url = `${path}/${ip}/actions`;
    return httpClient.get(url, { params: query_params });
};
exports.listFloatingIpActions = listFloatingIpActions;
//# sourceMappingURL=list-floating-ip-actions.js.map